export const getWaterMetadataTitle = (
  name: string,
  nearestPlaceName: string | undefined,
  regionName: string | null | undefined,
  countryName: string | undefined,
): string => {
  const prefix = `ᐅ ${name} fishing reports🎣`;

  if (!nearestPlaceName && !regionName && !countryName) {
    return prefix;
  }

  if (!nearestPlaceName && (regionName || countryName)) {
    const regionAndCountry =
      regionName && countryName ? `${regionName}, ${countryName}` : regionName || countryName;
    return `${prefix}• ${regionAndCountry} fishing`;
  }

  if (nearestPlaceName && (regionName || countryName)) {
    const regionAndCountry =
      regionName && countryName
        ? `, ${regionName} (${countryName})`
        : `, ${regionName || countryName}`;
    return `${prefix}• ${nearestPlaceName}${regionAndCountry} fishing`;
  }
  return `${prefix}• ${nearestPlaceName} fishing`;
};
